<template>
  <div>
    <section class="content-header" style="height: 50px;">
      <input type="button" value="Fill Dealer Dashboard" @click="fillDealerDashboard()" v-if="10>1" />
      <input type="button" value="Update MSI Url" @click="updateMsiUrl()" v-if="0>1" />
      <a v-show="0>1" href="#" @click="$root.showNewBox" style="float: left; padding-right: 10px;"><i class="fa fa-plus-circle" style="font-size: 30px;"></i></a>
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
      <div action="#" method="get" class="sidebar-form" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
      <div :class="['box-tools', $root.device.isMobile?'tabsMobile':'']" style="float: right; padding: 0px 10px;">
        <ul class="pagination pagination-sm inline" style="cursor: pointer;">
          <li v-if="!$root.device.isMobile" :class="[options.activeFilter==='All' ? 'active' : '']"><a @click="options.activeFilter='All'" style="width: 80px!important; text-align: center;">All</a></li>
          <li :class="[options.activeFilter==='Locked' ? 'active' : '']"><a @click="options.activeFilter='Locked'" style="width: 80px!important; text-align: center;">Locked</a></li>
          <li :class="[options.activeFilter==='Unlocked' ? 'active' : '']"><a @click="options.activeFilter='Unlocked'" style="width: 80px!important; text-align: center;">Unlocked</a></li>
        </ul>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <VueTable :columns="columns" :info="infoIcons" :rows="filteredItems" :pageSize="10" @rowClick="rowClick"></VueTable>
      </div>
    </div>
    <AddDealer></AddDealer>
    <va-modal></va-modal>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import AddDealer from '../components/AddDealer'
  import Modal from '../components/Modal'
  // import { func, db, dbListener, dbStore, dbStoreIncrease, dbStoreDecrease } from '../firebase'
  import { func, db, dbListener, dbStore } from '../firebase'
  export default {
    name: 'dealers',
    components: { VueTable, AddDealer, 'va-modal': Modal },
    data () {
      return {
        dealers: [],
        options: { showDefault: false, activeFilter: 'Unlocked' },
        infoIcons: [
          { icon: 'fa fa-check text-green', label: 'Verified' },
          { icon: 'fa fa-times text-red', label: 'Unverified' },
          { icon: 'fa fa-lock text-red', label: 'Locked' },
          { icon: 'fa fa-unlock  text-green', label: 'Unlocked' }
        ],
        lockCounter: 0,
        columns: [
          // { fieldName: 'Connected', label: '', isSortable: false, isHidden: false, isStatus: true },
          { fieldName: 'FullName', label: 'Dealer Name', isSortable: true, isHidden: false },
          { fieldName: 'CreateDate', label: 'Created', isSortable: true, isHidden: false },
          { fieldName: 'Email', label: 'Email', isSortable: true, isHidden: false, length: 80 },
          { fieldName: 'Company', label: 'Company', isSortable: true, isHidden: false },
          { fieldName: 'Country', label: 'Country', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'TotalCustomers', label: 'Total Customers', isSortable: true, isHidden: false },
          { fieldName: 'TotalSites', label: 'Total Sites', isSortable: true, isHidden: false },
          { fieldName: 'TotalPrinters', label: 'Total Printers', isSortable: true, isHidden: false },
          { fieldName: 'Verified', label: 'Verified', isSortable: true, isHidden: false, isBool: true },
          { fieldName: 'Locked', label: 'Locked', isSortable: true, isHidden: false, isLock: true },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'DealerInfo', label: 'Dealer Info', iconClass: 'fa fa-info-circle', color: '#3c8dbc', isLink: true, route: 'Dealer', param: '.key' },
              { name: 'Edit', label: 'Edit', iconClass: 'fa fa-edit', color: 'green' },
              { name: 'Delete', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'red' }
            ]
          }
        ]
      }
    },
    /*
    firebase: function () {
      var vm = this
      vm.$root.isLoading = true
      let dealersRef = db.ref('Dealers')
      return {
        dealers: {
          source: dealersRef.orderByChild('FullName'),
          asObject: false,
          cancelCallback: function () { },
          readyCallback: function () {
            console.log('vm.dealers = ' + vm.dealers.length)
            for (let i = 0; i < vm.dealers.length; i++) {
              console.log()
              let dealerT = vm.dealers[i]
              // dealerT.Email = '* Missing Email *'
              dealerT.Locked = true
              // dealerT.Country = dealerT.Country ? dealerT.Country : dealerT['.key']
              dealerT.Verified = false
            }
            db.ref('Users').orderByChild('UserType').equalTo('Dealer').once('value').then(function (snapItems) {
              const users = snapItems.val()
              if (users) {
                for (let i = 0; i < vm.dealers.length; i++) {
                  let dealer = vm.dealers[i]
                  let dealerKey = dealer['.key']
                  let user = users[dealerKey]
                  dealer.Email = '** Missing Email **'
                  // dealer.Country = dealerKey
                  if (user) {
                    dealer.Locked = user.Locked
                    dealer.Country = user.Country
                    dealer.Company = user.CompanyName
                    if (user.Email) {
                      dealer.Email = user.Email
                      dealer.Verified = user.Verified
                    }
                    db.ref('Printers').orderByChild('DealerKey').equalTo(dealerKey).once('value').then(function (snapItems) {
                      let printersUser = snapItems.val()
                      if (printersUser) {
                        dealer.TotalPrinters = Object.keys(printersUser).length
                        console.log(dealer.FullName)
                        console.log(dealer.FullName + '--' + Object.keys(printersUser).length)
                      }
                    })
                  }
                }
              }
              vm.$root.isLoading = false
            })
          }
        }
      }
    },
    */
    created () {
      this.$root.title = 'Dealers'
      this.loadDealers()
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            // result = vm.dealers.filter(function (row) {
            result = vm.allItems.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.allItems
        }
        // console.log(result)
        return result
      },
      allItems () {
        const vm = this
        let result = []
        try {
          if (vm.options.activeFilter === 'Locked') {
            for (let i = 0; i < vm.dealers.length; i++) {
              if (vm.dealers[i].Locked) {
                result.push(vm.dealers[i])
              }
            }
          } else if (vm.options.activeFilter === 'Unlocked') {
            for (let i = 0; i < vm.dealers.length; i++) {
              if (!vm.dealers[i].Locked) {
                result.push(vm.dealers[i])
              }
            }
          } else {
            result = vm.dealers
          }
        } catch (e) {
          console.log(e)
          result = []
        }
        // console.log(result)
        return result
      }
    },
    watch: {
      'options.activeFilter' (val) {
        console.log('watch: options.activeFilter = ' + val)
      },
      lockCounter (val) {
        console.log('lockCounter = ' + val)
        this.$forceUpdate()
      },
      '$root.txtSearch' (val) {
        console.log('watch $root.txtSearch = ' + val)
      }
    },
    methods: {
      loadDealers () {
        var vm = this
        vm.$root.isLoading = true
        let dealersRef = db.ref('Dealers')
        dealersRef.orderByChild('FullName').once('value', (snapDealers) => {
          vm.dealers = []
          const data = snapDealers.val()
          if (data) {
            db.ref('Users').orderByChild('UserType').equalTo('Dealer').once('value').then(function (snapItems) {
              const users = snapItems.val()
              if (users) {
                const dealersKeys = Object.keys(data)
                for (let i = 0; i < dealersKeys.length; i++) {
                  let dKey = dealersKeys[i]
                  if (typeof data[dKey] === 'object') {
                    let dealerT = {
                      '.key': dKey,
                      FullName: data[dKey].FullName,
                      CreateDate: data[dKey].CreateDate ? data[dKey].CreateDate : '2021-01-01 12:00:00',
                      Email: data[dKey].Email, // '* Missing Email *'
                      Company: data[dKey].Company,
                      Country: data[dKey].Country,
                      TotalCustomers: data[dKey].TotalCustomers,
                      TotalSites: data[dKey].TotalSites,
                      TotalPrinters: data[dKey].TotalPrinters,
                      Verified: false,
                      Locked: true
                    }
                    console.log('>>>>>>>>>>>>>>>>>> IsDailyCounters = ' + data[dKey].IsDailyCounters)

                    dealerT.TotalCustomers = ''
                    dealerT.TotalSites = ''
                    dealerT.TotalPrinters = ''

                    let user = users[dKey]
                    if (user) {
                      dealerT.Locked = user.Locked
                      dealerT.Country = user.Country
                      dealerT.Company = user.CompanyName
                      if (user.Email && user.Email.length > 0) {
                        dealerT.Email = user.Email
                        dealerT.Verified = user.Verified
                      }
                    }
                    vm.dealers.push(dealerT)
                  }
                }
              }
            })
          }
          vm.$root.isLoading = false
        })
      },
      updateMsiUrl () {
        let vm = this
        for (let i = 0; i < vm.dealers.length; i++) {
          if (vm.dealers[i].InstallerLinks) {
            // vm.dealers[i].InstallerLinks.Lan = vm.dealers[i].InstallerLinks.Lan.replace('http:', 'https:')
            // vm.dealers[i].InstallerLinks.Usb = vm.dealers[i].InstallerLinks.Usb.replace('http:', 'https:')
            // vm.dealers[i].InstallerLinks.Lan = vm.dealers[i].InstallerLinks.Lan.replace('108.163.133.79', 'www.printercountersdownloads.com')
            // vm.dealers[i].InstallerLinks.Usb = vm.dealers[i].InstallerLinks.Usb.replace('108.163.133.79', 'www.printercountersdownloads.com')
            console.log(i + ': ' + vm.dealers[i]['.key'] + ' : ' + JSON.stringify(vm.dealers[i].InstallerLinks))
            console.log(' = = = = = =  = = = = = =  = = = = = = ')
            // db.ref('Dealers/' + vm.dealers[i]['.key'] + '/InstallerLinks').set(vm.dealers[i].InstallerLinks)
          }
        }
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'Lock': this.confirmLock(item); break
          case 'Edit': this.edit(item); break
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      lock (item) {
        this.$bus.$emit('dealerModal-open', item)
      },
      edit (item) {
        this.$bus.$emit('dealerModal-open', item)
      },
      confirmLock (item) {
        console.log(item)
        const vm = this
        let isLocked = true
        if (item.Locked) {
          isLocked = false
        } else {
          isLocked = true
        }
        let title = 'Lock Dealer'
        let description = 'Are you sure you want to lock'
        if (item.Locked) {
          title = 'Unlock Dealer'
          description = 'Are you sure you want to unlock'
        }
        description = description + ' dealer [' + item.FullName + ']'
        vm.$bus.$emit('modal-open', {
          title: title,
          description: description,
          type: 'modal-primary',
          confirmText: item.Locked ? 'Unlock' : 'Lock',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            for (let i = 0; i < vm.dealers.length; i++) {
              let dealer = vm.dealers[i]
              if (dealer['.key'] === item['.key']) {
                const temp = item.TotalPrinters
                item.TotalPrinters = -1
                if (item.Locked) {
                  item.Locked = false
                } else {
                  item.Locked = true
                }
                item.TotalPrinters = temp
                break
              }
            }
            // item
            db.ref('Users').orderByChild('DealerUID').equalTo(item['.key']).once('value').then(function (snapItems) {
              snapItems.forEach(function (user) {
                console.log(user)
                console.log(item)
                console.log(item.Locked)
                if (item.Locked) {
                  user.ref.update({ Locked: true })
                } else {
                  user.ref.update({ Locked: false })
                }
              })
              vm.$forceUpdate()
            })
            // Abed Ali
            // 09/02/2023
            // Block All Clients of this Dealer
            let dealerPath = 'Dealers/' + item['.key']
            let dealerRef = db.ref(dealerPath)
            dealerRef.once('value').then(function (snapDealer) {
              let dataDealer = snapDealer.val()
              console.log(dataDealer)
              if (dataDealer) {
                if (dataDealer.Customers) {
                  console.log(dataDealer.Customers)
                  let custKeys = Object.keys(dataDealer.Customers)
                  for (let i = 0; i < custKeys.length; i++) {
                    let custKey = custKeys[i]
                    let cust = dataDealer.Customers[custKey]
                    console.log('custKey = ' + custKey)
                    console.log('cust.Name = ' + cust.Name)
                    if (cust.Sites) {
                      let sitesKeys = Object.keys(cust.Sites)
                      for (let j = 0; j < sitesKeys.length; j++) {
                        let siteKey = sitesKeys[j]
                        let site = cust.Sites[siteKey]
                        console.log('siteKey = ' + siteKey)
                        console.log('site.Name = ' + site.Name)
                        dbListener.ref('UpdateClient/' + siteKey + '/Locked').set(isLocked)
                      }
                    }
                  }
                }
              }
            })
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      confirmDelete (item) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Delete Dealer',
          descriptionOLD: 'Are you sure you want to delete dealer [' + item.FirstName + ' ' + item.LastName + ']',
          description: 'Are you sure you want to delete dealer [' + item.FullName + ']',
          checkText: 'Delete all data of this dealer (Customers / Sites / Printers / Users)',
          isChecked: true,
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            const dealerRef = db.ref('Dealers/' + item['.key'])
            dealerRef.remove()
            db.ref('Dashboard/Admin/TotalDealers').once('value').then(function (snapTotalDealers) {
              let totalDealers = snapTotalDealers.val()
              db.ref('Dashboard/Admin/TotalDealers').set(totalDealers - 1)
            })
          },
          forceAfter: () => {
            // alert('Delete all data of this dealer [' + item['.key'] + '] (Customers / Sites / Printers / Users)')
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      fillDealerDashboard () {
        // let vm = this
        // vm.TestPrintersGeneral()
        // vm.TestGenerateDealerMSI()
        let adminDashboard = {
          TotalDealers: 0,
          TotalCustomers: 0,
          TotalSites: 0,
          TotalPrinters: 0,
          TotalUsers: 0,
          PrintersStatus: {
            TotalOnline: 0,
            TotalOffline: 0,
            TotalOutPaper: 0,
            TotalOutToner: 0,
            TotalError: 0
          }
        }

        let dealerDashboard = {
          TotalCustomers: 0,
          TotalSites: 0,
          TotalPrinters: 0,
          TotalUsers: 0,
          PrintersStatus: {
            TotalOnline: 0,
            TotalOffline: 0,
            TotalOutPaper: 0,
            TotalOutToner: 0,
            TotalError: 0
          }
        }

        db.ref('Dealers').orderByChild('FullName').once('value', (snapDealers) => {
          let dataDealers = snapDealers.val()
          if (dataDealers) {
            let dealersKeys = Object.keys(dataDealers)
            adminDashboard.TotalDealers = dealersKeys.length
            console.log(dataDealers)

            db.ref('Users').once('value').then(function (snapUsers) {
              if (snapUsers.val()) {
                let dataUsers = snapUsers.val()
                let usersKeys = Object.keys(dataUsers)
                adminDashboard.TotalUsers = usersKeys.length
                console.log(dataUsers)
                for (let i = 0; i < dealersKeys.length; i++) {
                  if (i > 20) { return }
                  let dKey = dealersKeys[i]
                  let dealer = dataDealers[dKey]
                  console.log(dealer)
                  for (let u = 0; u < usersKeys.length; u++) {
                    let uKey = usersKeys[u]
                    console.log(uKey)
                    console.log(dKey)
                    console.log(dataUsers[uKey].DealerUID)
                    console.log((dataUsers[uKey].DealerUID === uKey))
                    if (dataUsers[uKey].DealerUID === uKey) {
                      dealerDashboard.TotalUsers++
                    }
                  }

                  if (dealer.Customers) {
                    let customersKeys = Object.keys(dealer.Customers)
                    dealerDashboard.TotalCustomers = customersKeys.length
                    console.log('customersKeys.length = ' + customersKeys.length)
                    adminDashboard.TotalCustomers += dealerDashboard.TotalCustomers
                    for (let j = 0; j < customersKeys.length; j++) {
                      let cKey = customersKeys[j]
                      console.log('customersKey = ' + cKey)
                      let customer = dealer.Customers[cKey]
                      if (customer.Sites) {
                        let sitesKeys = Object.keys(customer.Sites)
                        dealerDashboard.TotalSites = sitesKeys.length
                        console.log('sitesKeys.length = ' + sitesKeys.length)
                        adminDashboard.TotalSites += dealerDashboard.TotalSites
                      }
                    }
                  }
                  // dealerDashboard.PrintersStatus.TotalOnline = dbStoreIncrease
                  // dealerDashboard.PrintersStatus.TotalOffline = dbStoreDecrease
                  dbStore.collection('/Dashboard').doc(dKey).set(dealerDashboard)
                }

                console.log(adminDashboard)
                dbStore.collection('/Dashboard').doc('Admin').set(adminDashboard)
              }
            })
          }
        })
      },
      TestGenerateDealerMSI () {
        // let vm = this
        console.log('GenerateDealerMSI() ... ')
        let GenerateDealerMSI = func.httpsCallable('GenerateDealerMSI')
        let UID = '123123123123'
        GenerateDealerMSI({ UID: UID }).then((result) => {
          console.log(result)
          let InstallerLinks = {
            Lan: 'https://www.printercountersdownloads.com/PrinterCountersWS/Downloads/' + UID + '/Network/NetworkPrinterCounters@' + UID + '@.msi',
            Usb: 'https://www.printercountersdownloads.com/PrinterCountersWS/Downloads/' + UID + '/Local/LocalPrinterCounters@' + UID + '@.msi'
          }
          console.log(InstallerLinks)
        })
      },
      TestPrintersGeneral () {
        // let vm = this
        console.log('TestPrintersGeneral() ... ')
        let printer = {
          MacAddress: '30-CD-A7-C3-7D-F2',
          CustomerKey: '-MLMkL8GO-vEy4FesVQj',
          DealerKey: '0Z8VimcxCtMvmTSqLR7Nua6F8Nz2',
          SiteKey: 'AA5050BB',
          GeneralData: '/PrintersGeneral/Dealers/0Z8VimcxCtMvmTSqLR7Nua6F8Nz2/Customers/-MLMkL8GO-vEy4FesVQj/Printers/30-CD-A7-C3-7D-F2/Data'
        }
        let docPath = ''
        docPath += 'Dealers/'
        docPath += printer.DealerKey + '/'
        docPath += 'Customers/'
        docPath += printer.CustomerKey + '/'
        docPath += 'Printers/'
        docPath += printer.MacAddress + '/'
        docPath += 'Data/'

        dbStore.collection('PrintersGeneral/').doc(docPath).set(printer).then(function (result) {
          console.log('LogGeneralDataPrinter Pushed [Logged]:[MacAddress]: ' + printer.Logged + ' : ' + printer.MacAddress)
        }).catch(function (err) {
          console.log('Error (' + printer.MacAddress + '): ' + err.message)
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Dealers.vue?39524bda